import Page from 'components/Page';
import React from 'react';
import {Button, ButtonGroup, Card, CardBody, CardHeader, Col, FormGroup, Input, Label, Row, Table,} from 'reactstrap';
import BasePage from './BasePage';
import Global, {DD_MM_YYYY_HH_MM_SS,} from '../utils/Global';
import {cloneObject, isEmpty, navigateBack, parseDate} from '../utils/Utilities';
import {MdAdd, MdArrowBack, MdDelete, MdEdit, MdSave} from 'react-icons/md';
import ConfirmDialog from '../components/modal/ConfirmDialog';
import label from 'enqc-utilities/src/label/Label'
import WarningLabel from "../components/Widget/WarningLabel";
import ComponentItemDialog from "../components/modal/ComponentItemDialog";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import queryString from "query-string";
import PrimaryCardHeader from "../components/Widget/PrimaryCardHeader";
import MasterComponentSelectionModal from "../components/modal/MasterComponentSelectionModal";

const tableTypes = ['', 'bordered', 'striped', 'hover'];


class ComponentGroupDetailPage extends BasePage{

  validator = {
    labelError: false,
    descriptionError:false,
    componentError:false
  }

  constructor(props) {
    super(props);
    this.state = {
      componentItems:[],
      componentItem:{},
      componentGroup:{},
      componentGroupId : queryString.parse(this.props.query).id,
      masterComponentSelectionModal:false,
      componentItemDialogModal:false,
      modalAddConfirm:false,
      modalDeleteConfirm:false,
      modal: false,
      ascending:true,
      sortir:'jci.label',
      validator : this.validator
    }
  }

  componentDidMount() {
    super.componentDidMount();
    let {componentGroupId} = this.state
    if(componentGroupId){
      this.fetchComponentGroupDetail(componentGroupId)
    }
  }

  confirmSave = () =>{
    let {componentGroup, componentItems, validator} = this.state
    let valid = true ;
    if(componentItems.length==0){
      validator.componentError = true
      valid = false ;
    }
    this.setState({validator}, () => {
      if(valid){
        componentGroup.componentItems = componentItems
        this.setState({ componentGroup, modalAddConfirm:true})
      }
    })
  }

  fetchComponentGroupDetail = (id) => {
    if(id!=null){
      this.get(Endpoint.API.COMPONENT_GROUP, {
        params :{
          id : id
        }
      }, null, res=>{
        if(res.code===200){
          let componentGroup = res.data;
          let componentItems = componentGroup.componentItems ;
          this.setState({componentGroup, componentItems})
        }else{
          this.props.history.goBack();
        }
      }, true, true);
    }
  }


  saveUpload = () => {
    let {componentGroup} = this.state

    this.setState({
      modalAddConfirm:false
    }, () => {
      this.post(Endpoint.API.COMPONENT_GROUP_SAVE, componentGroup, null, res=>{
        if(res.code===200){
          this.setState({
            componentGroup:res.data
          }, () => {
            this.successToast(res.message)
            setTimeout(()=>{
              navigateBack(this.props)
            }, 1000)
          })
        }
      },  true, true)
    })
  }


  confirmDelete = () =>{
    this.setState({
      modalDeleteConfirm:true
    })
  }

  delete = () => {
    this.setState({
      modalDeleteConfirm:false
    }, () => {
      this.get(Global.API.MAIN_MODEL_DELETE+"/"+this.state.componentGroup.id, null, null, res => {
        if(res.code===200){
          this.setState({
            componentGroup:{},
            componentItem:{}
          }, () => {
            this.fetchAll()
          })
        }
      },true, true);
    })
  }

  closeDialog = () =>{
    this.setState({
      modalAddConfirm:false,
      modalDeleteConfirm:false
    })
  }

  refresh = (ascending, sortir) => (
      this.setState({
        ascending:ascending,
        sortir:sortir
      })
  )


  render() {
    let aspect = 4/4
    let {componentItemDialogModal, masterComponentSelectionModal} = this.state
    let componentGroup = this.state.componentGroup??{}
    let componentItems = this.state.componentItems??{}
    let componentItem = this.state.componentItem??{}
    let validator = this.state.validator??{}

    let exclusionMasterComponents = []
    componentItems.forEach((value, index)=>{
      if(value.masterComponent) {
        exclusionMasterComponents.push(value.masterComponent)
      }
    })

    return (
        <Page
            title={label.ComponentGroup}
            breadcrumbs={[{ name: label.ComponentGroup, active: true }]}
            className="TablePage">
          {super.render()}
          <ConfirmDialog
              showing={this.state.modalAddConfirm}
              title={label.UpdateConfirmation}
              message={label.UpdateConfirmationMessage}
              okCallback={this.saveUpload}
              cancelCallback={this.closeDialog}/>
          <ConfirmDialog
              showing={this.state.modalDeleteConfirm}
              title={label.DeleteConfirmationTitle}
              message={label.DeleteConfirmationMessage}
              okCallback={this.delete}
              cancelCallback={this.closeDialog}/>
          <ComponentItemDialog
              modal={componentItemDialogModal}
              componentItem={componentItem}
              okCallback={(componentItem) => {
                if(componentItem.id>0){
                  let edited = -1;
                  componentItems.forEach((value, index) => {
                    if(value.id===componentItem.id){
                      edited = index
                    }
                  })
                  componentItems[edited] = componentItem;
                  this.setState({componentItems})
                }else{
                  componentItems.push(componentItem)
                }
                validator.componentError = false
                this.setState({validator, componentItems, componentItem:{}, componentItemDialogModal:false})
              }}
              cancelCallback={() => {
                this.setState({componentItemDialogModal:false})
              }}
          />
          <MasterComponentSelectionModal
              show={masterComponentSelectionModal}
              okCallback={(selectedMasterComponents) => {
                selectedMasterComponents.forEach((item)=>{
                  let exist = false
                  componentItems.forEach((componentItem)=>{
                    if(componentItem.masterComponent?.id===item.id){
                      componentItem.quantity += item.quantity
                      exist = true
                    }
                  })
                  if(!exist){
                    let componentItem = {
                      masterComponent:item,
                      quantity:item.quantity,
                      created:new Date(),
                      updated:new Date(),
                    }
                    componentItems.push(componentItem)
                  }
                })
                this.setState({masterComponentSelectionModal:false})
              }}
              cancelCallback={() => {
                this.setState({masterComponentSelectionModal:false})
              }}/>
          <Row key={1}>
            <Col>
              <Card>
                <PrimaryCardHeader content={label.ComponentGroupDetail}/>
                <CardBody >
                  <Row>
                    <Col md={3}>
                      <Card>
                        <CardHeader>{label.Information}</CardHeader>
                        <CardBody>
                          <Row>
                            <Col>
                              <FormGroup>
                                <Label for="name">{label.ModelName}</Label>
                                <Input
                                    type="text"
                                    name="label"
                                    readOnly
                                    value={componentGroup.model?.modelName}
                                />
                              </FormGroup>
                              <FormGroup>
                                <Label for="name">{label.SystemType}</Label>
                                <Input
                                    type="text"
                                    name="label"
                                    readOnly
                                    value={componentGroup.model?.systemType}
                                />
                              </FormGroup>
                              <FormGroup>
                                <Label for="name">{label.PartName}</Label>
                                <Input
                                    type="text"
                                    name="label"
                                    readOnly
                                    value={componentGroup.model?.partName}
                                />
                              </FormGroup>
                              <FormGroup>
                                <Label for="name">{label.PartNumber}</Label>
                                <Input
                                    type="text"
                                    name="description"
                                    readOnly
                                    value={componentGroup.model?.partNumber}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col md={9}>
                      <Card body>
                        <Row>
                          <Col md={6}>
                            <ButtonGroup className="float-left">
                              <Button color="danger" onClick={e => {
                                this.props.history.goBack()
                              }}><MdArrowBack/> {label.Back}</Button>
                              &nbsp;&nbsp;
                              <Button color="primary" onClick={e=>(
                                  this.confirmSave()
                              )}> {
                                (componentGroup && componentGroup.id)?label.Update:label.Save
                              } <MdSave/></Button>
                            </ButtonGroup>

                          </Col>
                          <Col md={6}>
                            <ButtonGroup className="float-right">
                              <Button
                                  className="btn-outline-secondary"
                                  color="light"
                                  onClick={e=>{
                                this.setState({masterComponentSelectionModal:true})
                              }}><MdAdd/>&nbsp;{label.AddItem}</Button>
                            </ButtonGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Table responsive hover>
                              <thead>
                              <tr>
                                <th>#</th>
                                <th>{label.Label}</th>
                                <th>{label.Description}</th>
                                <th>{label.CharacterLength}</th>
                                <th>{label.Quantity}</th>
                                <th>{label.Created}</th>
                                <th>{label.Delete}</th>
                              </tr>
                              </thead>
                              <tbody>
                              {
                                componentItems.map((item, index) =>(
                                    <tr key={index}>
                                      <th scope="row">{++index}</th>
                                      <td>{item.masterComponent?.label}</td>
                                      <td>{item.masterComponent?.description}</td>
                                      <td>{item.masterComponent?.length}</td>
                                      <td><span className="font-weight-bold fs-6">{item.quantity}</span></td>
                                      <td>{parseDate(item.created, DD_MM_YYYY_HH_MM_SS)}</td>
                                      <td>
                                        <Button color="danger" onClick={e=> {
                                          let componentItem = cloneObject(item)
                                          let i = 0 ;
                                          componentItems.forEach((value, index1) => {
                                            if(componentItem.id === value.id){
                                                i = index1;
                                            }
                                          })
                                          componentItems.splice(i, 1);
                                          this.setState({
                                            componentItems: componentItems
                                          })
                                        }}>
                                          <MdDelete/>
                                        </Button>
                                      </td>

                                    </tr>
                                ))
                              }
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                        <WarningLabel show={validator.componentError} message={label.AddAtLeastOneComponentToGroup}/>
                      </Card>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>


        </Page>
    );
  }
}

export default Object.assign(ComponentGroupDetailPage, {ENDPOINT : "/componentGroupDetail"})
